















































// import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  UnitBaseData, emptyData, viewUnitInfo
} from '@/api/heritageUnit/unitBase'
import OtherUnitBaseView from './base.vue'
import UnitFilesView from '@/components/heritageUnit/view/files.vue'
import DynamicFiles from '@/components/upload/dynamicFiles.vue'
import ViewDialog from '@/components/dialog/viewDialog.vue'
import UnitActionsView from '@/components/heritageUnit/view/actions.vue'

@Component({
  components: {
    ViewDialog, OtherUnitBaseView, UnitFilesView, DynamicFiles, UnitActionsView
  }
})
export default class OtherUnitView extends Vue {
  public tabName: string = 'baseInfo'
  public showDialog: boolean = false
  public loading: boolean = false

  public hasFiles: boolean = false
  public hasAttach: boolean = false
  public picForm: any = {
    Pictures: [],
    Drawings: []
  }
  public form: UnitBaseData = Object.assign({}, emptyData)
  public $refs!: {
    filesViewCtrl: UnitFilesView
    dynamicFilesCtrl: DynamicFiles
  }
  public tabClick(tab: any, event: any) {
    const tabName = tab.name
  }
  public created() { }
  public mounted() {
    window.eventBus.$on('viewOtherUnit', (id: number) => {
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('viewOtherUnit')
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.loading = true
    viewUnitInfo(id)
      .then((response: { data: any }) => {
        this.form = response.data
        this.setCtrls()
        this.tabName = 'baseInfo'
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
  public setCtrls() {
    this.setPic()
    this.setAttach()
  }
  public setAttach() {
    const attachs = this.form.OtherDynamicAttachs
    this.hasAttach = attachs.length > 0
    if (this.hasAttach) {
      this.$nextTick(() => {
        console.log(this.$refs.dynamicFilesCtrl)
        if (this.$refs.dynamicFilesCtrl) {
          this.$refs.dynamicFilesCtrl.setData(attachs)
        }
      })
    }
  }
  public setPic() {
    const pic = this.form.Pictures
    const draw = this.form.Drawings
    this.hasFiles = pic.length > 0 || draw.length > 0
    this.picForm = {
      Pictures: pic,
      Drawings: draw
    }
    if (this.hasFiles) {
      this.$nextTick(() => {
        this.$refs.filesViewCtrl.setForm(this.picForm)
      })
    }
  }
}
